// test1046
(1046 && 0);
